const ExploreActionTypes = {
	FETCH_REGION_PROPERTIES_START: 'FETCH_REGION_PROPERTIES_START',
	FETCH_REGION_PROPERTIES_SUCCESS: 'FETCH_REGION_PROPERTIES_SUCCESS',
	FETCH_REGION_PROPERTIES_FAILURE: 'FETCH_REGION_PROPERTIES_FAILURE',
	EMPTY_REGION_PROPERTIES: 'EMPTY_REGION_PROPERTIES',
};

export default ExploreActionTypes;
